import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, TextField, Divider, Grid } from '@mui/material'

import { trackPageView } from 'utils/mixpanel'

import { getLanguage } from 'data/locale'
import { changePassword, changeUsername, logoutUser, redirectTo } from 'store/actions/user'
import { selectIsLibraryMode, selectUser } from 'store/selectors/user'

const UserProfilePage = () => {
  const { t } = getLanguage()
  const dispatch = useDispatch()

  const isLibraryMode = useSelector(selectIsLibraryMode)
  const { username } = useSelector(selectUser)

  const [newUsername, setNewUsername] = useState('')
  const [usernameValid, setUsernameValid] = useState(false)
  const [newUsernameError, setNewUsernameError] = useState('')

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [passwordValid, setPasswordValid] = useState(false)
  const [currentPasswordError, setCurrentPasswordError] = useState('')
  const [newPasswordError, setNewPasswordError] = useState('')
  const [passwordRepeatError, setPasswordRepeatError] = useState('')

  useEffect(() => {
    trackPageView()
  }, [])

  useEffect(() => {
    if (isLibraryMode) {
      dispatch(redirectTo('/search'))
    }
  }, [isLibraryMode])

  const handleNewUsernameChange = e => {
    validateUsername(e.target.value)
    setNewUsername(e.target.value)
  }

  const handleCurrentPasswordChange = e => {
    validatePassword(e.target.value, newPassword, repeatPassword)
    setCurrentPassword(e.target.value)
  }

  const handleNewPasswordChange = e => {
    validatePassword(currentPassword, e.target.value, repeatPassword)
    setNewPassword(e.target.value)
  }

  const handleRepeatPasswordChange = e => {
    validatePassword(currentPassword, newPassword, e.target.value)
    setRepeatPassword(e.target.value)
  }

  const validateUsername = newUsername => {
    const empty = ''
    let isValid = true

    if (newUsername === empty) {
      setNewUsernameError(t.user.fieldRequired)
      isValid = false
    }
    if (newUsername === username) {
      setNewUsernameError(t.user.profileEdit.newUsernameError)
      isValid = false
    }
    if (isValid) {
      setNewUsernameError(empty)
    }
    setUsernameValid(isValid)
  }

  const validatePassword = (current, newPassword, repeat) => {
    const empty = ''
    let isValid = true

    if (current === empty) {
      setCurrentPasswordError(t.user.fieldRequired)
      isValid = false
    }
    if (newPassword === empty) {
      setNewPasswordError(t.user.fieldRequired)
      isValid = false
    }
    if (repeat === empty) {
      setPasswordRepeatError(t.user.fieldRequired)
      isValid = false
    }
    if (newPassword === current) {
      setNewPasswordError(t.user.profileEdit.newPasswordError)
      isValid = false
    }
    if (newPassword !== repeat) {
      setPasswordRepeatError(t.user.updatePasswordError)
      isValid = false
    }
    if (isValid) {
      setCurrentPasswordError(empty)
      setNewPasswordError(empty)
      setPasswordRepeatError(empty)
    }
    setPasswordValid(isValid)
  }

  const submitNewUsername = async () => {
    await dispatch(changeUsername(newUsername))
    dispatch(logoutUser())
  }

  const submitNewPassword = async () => {
    const result = await dispatch(changePassword(currentPassword, newPassword))
    if (result.success) {
      dispatch(logoutUser())
    } else {
      setCurrentPasswordError(result.error)
    }
  }

  return (
    <div className="main user-edit">
      <Grid container>
        <Grid size={{ xs: 12, md: 9 }}>
          <form>
            <h2> {t.user.profileEdit.editUsername} </h2>
            <TextField
              id="username"
              label={t.user.profileEdit.actualUsername}
              value={username}
              variant="standard"
              autoComplete="off"
            />
            <TextField
              id="newusername"
              label={t.user.profileEdit.newUsername}
              onChange={handleNewUsernameChange}
              error={!!newUsernameError}
              helperText={newUsernameError}
              variant="standard"
            />
            <Button disabled={!usernameValid} onClick={submitNewUsername}>
              {t.user.profileEdit.submitUsername}
            </Button>
          </form>
          <Divider />
          <form>
            <h2> {t.user.profileEdit.editPassword} </h2>
            <TextField
              id="actualpassword"
              type="password"
              label={t.user.profileEdit.actualPassword}
              onChange={handleCurrentPasswordChange}
              error={!!currentPasswordError}
              helperText={currentPasswordError}
              variant="standard"
            />
            <TextField
              id="newpassword"
              type="password"
              label={t.user.updatePassword}
              onChange={handleNewPasswordChange}
              error={!!newPasswordError}
              helperText={newPasswordError}
              variant="standard"
            />
            <TextField
              id="newpasswordrepeat"
              type="password"
              label={t.user.updatePasswordRepeat}
              onChange={handleRepeatPasswordChange}
              error={!!passwordRepeatError}
              helperText={passwordRepeatError}
              variant="standard"
            />
            <Button disabled={!passwordValid} onClick={submitNewPassword}>
              {t.user.profileEdit.submitPassword}
            </Button>
          </form>
        </Grid>
      </Grid>
    </div>
  )
}

export default UserProfilePage
